import CookiesComponent from 'components/marketingSite/cookies/CookiesComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';

type CookiesPageProps = WithBaseUrl;

const CookiesPage: React.FC<CookiesPageProps> = () => {
  const { t } = useI18n('web');

  usePageTrack('Website - Page Loaded');

  return (
    <>
      <HeadMetadata url={APP_URLS.cookies} title={t('cookies.title')} />
      <CookiesComponent />
    </>
  );
};

export default CookiesPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'web'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
